<nav class="navbar navbar-light bg-light navbar-expand-md">
    <a class="navbar-brand" [routerLink]="['/']">{{title}}</a>
    <ul class="nav navbar-nav">
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link" [routerLink]="['/welcome']">Home</a>
        </li>
        <li *ngIf="!isLoggedIn" class="nav-item" routerLinkActive="active">
            <a class="nav-link" queryParamsHandling="merge" [routerLink]="['/login']">Login</a>
        </li>
        <li *ngIf="isLoggedIn" class="nav-item" routerLinkActive="active">
            <a class="nav-link" (click)="logout()">Logoff [{{displayName}}]</a>
        </li>
        <li *ngIf="isLoggedIn" class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/protectedPage']">Protected Page</a>
        </li>
        <li *ngIf="isLoggedIn" class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/callProtectedApi']">‍‍Call Protected Api</a>
        </li>
        <li *ngIf="isLoggedIn" class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/changePassword']">Change Password</a>
        </li>

    </ul>
</nav>
<div class="example-config">
    <label>
        Locale
        <select [value]="localeId" (change)="onLocaleChange($event)">
            <option value="en-US">en-US</option>
            <option value="bg-BG">bg-BG</option>
            <option value="de-DE">de-DE</option>
        </select>
    </label>
</div>
<h3>Numbers</h3>
<ul>
    <li>{{ value | kendoNumber : "c" : localeId }}</li>
    <li>{{ intlService.formatNumber(value, "c") }}</li>
</ul>
<h3>Dates</h3>
<ul>
    <li>{{ date | kendoDate : "d" : localeId }}</li>
    <li>{{ intlService.formatDate(date, "d") }}</li>
</ul>
